import {
    request,
    requestMedia,
    requestPost,
    requestMedia3
}
    from './request';
export default {
    sumCount(data) {
        return request('/api/historyCount/sumCount', data);
    },
    listHistoryCount(data) {
        return request('/api/historyCount/list', data);
    },
    selectGroupByIdHistoryCount(data) {
        return request('/api/historyCount/selectGroupById/'+data.id, data);
    },
    downloadHistoryCount(data){
        return requestMedia3('/api/historyCount/download?startDate='+data[0]+'&endDate='+data[1],data)
    }
}


// WEBPACK FOOTER //
// ./src/libs/axios/chatHistoryCount.js